import {
  InstagramIcon,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
  TiktokIcon,
  BlueskyIcon,
  MastodonIcon,
  YoutubeIcon,
  ThreadsIcon,
  TwitterIcon,
  CounterInput,
  Flex,
} from '@buffer-mono/popcorn'
import UXMessaging, { type MessageStatus } from '../UXMessaging/UXMessaging'

import { ChannelsContainer, Icons, Title } from './Channels.style'

type ChannelsProps = {
  channelsCount: number
  onDecreaseCounter: () => void
  onIncreaseCounter: () => void
  setChannelsCounterValue: (value: number) => void
  channelCounterMessageStatus: MessageStatus | null
  isSmallLayout: boolean
}

const Channels = ({
  channelsCount = 0,
  onDecreaseCounter,
  onIncreaseCounter,
  setChannelsCounterValue,
  channelCounterMessageStatus = null,
  isSmallLayout = false,
}: ChannelsProps): JSX.Element => {
  return (
    <ChannelsContainer>
      <Title isInline={isSmallLayout}>
        <span>Channels</span>
        <Icons isInline={isSmallLayout}>
          <InstagramIcon size="xsmall" color="subtle" />
          <FacebookIcon size="xsmall" color="subtle" />
          <TwitterIcon size="xsmall" color="subtle" />
          <PinterestIcon size="xsmall" color="subtle" />
          <LinkedinIcon size="xsmall" color="subtle" />
          <TiktokIcon size="xsmall" color="subtle" />
          <MastodonIcon size="xsmall" color="subtle" />
          <YoutubeIcon size="xsmall" color="subtle" />
          <ThreadsIcon size="xsmall" color="subtle" />
          <BlueskyIcon size="small" color="subtle" />
          <span>+1</span>
        </Icons>
      </Title>

      <Flex
        justify="center"
        align="center"
        style={{ marginBottom: 'var(--space-xs)' }}
      >
        <CounterInput
          value={channelsCount}
          onChange={(value: number): void => setChannelsCounterValue(value)}
          min={1}
          size="large"
        />
      </Flex>
      {channelCounterMessageStatus && (
        <UXMessaging
          messageStatus={channelCounterMessageStatus.messageStatus}
          message={channelCounterMessageStatus.message}
        />
      )}
    </ChannelsContainer>
  )
}

export default Channels
